
import { IDoctorListItem } from "@/models/doctor";
import OverlayPanel from "primevue/overlaypanel";
import { defineComponent, PropType, reactive, Ref, ref } from "vue";
import { useI18n } from "vue-i18n"

import DoctorItem from "@/components/common/Doctors/DoctorItem.vue";

export default defineComponent({
  emits: ["toggleFavorit"],
  props: {
    doctor: {
      type: Object as PropType<IDoctorListItem>,
      required: true,
    },
    isProfile: {
      type: Boolean,
      default: false,
    },
    isFavorit: {
      type: Boolean,
      default: false,
    },
  },
  name: "DoctorItemOptions",
  setup(props, { emit, slots }) {
    const state = reactive({
      isProfile: props.isProfile,
      isFavorit: props.isFavorit,
      isDetail: !slots["detail"],
    });

    //console.log(props.doctor, 'DOctorItem.doctor');

    const selectedDoctor = ref(props.doctor);
    const op$: Ref<OverlayPanel | null> = ref(null);
    const descMore = ref("");
    const opToggle = (event: any, profile: string) => {
      console.log(op$.value?.toggle);
      event?.preventDefault();
      descMore.value = profile;
      op$.value?.toggle(event);
    };

    const {t} = useI18n();

    /**
     * 의사 즐겨찾기(마이닥터) click event
     */
    const toggleFavorites = () => {
      emit("toggleFavorit", selectedDoctor.value);
    };

    return { selectedDoctor, opToggle, op$, descMore, state, toggleFavorites, t };
  },

  components: {
    DoctorItem,
    OverlayPanel,
  },
});
